// extracted by mini-css-extract-plugin
export default {"bgLoading":"LoadingComponent_bgLoading__ipPv8"};